module.exports = __webpack_public_path__ + "static/media/download-button.703b6786.svg";